// export const baseURL = 'http://10.0.2.2:5000/';

// export const baseURL = 'https://c4a3818f6dfc.ngrok-free.app/';

// export const baseURL = 'https://mbts.onrender.com/';

// Web ITV uses server.mjs proxy — this is for legacy mobile screens only.
export const baseURL = process.env.REACT_APP_BOTCIERGE_API_URL || 'https://mybots-api.herokuapp.com/';

// Relying party that issues the sign-in email codes and checks Google tokens.
// Called straight from the browser: it returns CORS headers for our origin.
export const RP_BASE = process.env.REACT_APP_RP_BASE || 'https://helperbots.ai/wp-json/mbts/v1/';

// The one switch for the OTP + Google leg of the auth gate. Every otp/* and
// google/* request reads this and nothing else, so moving that leg to another
// host is a single edit here — no call sites change.
// Held on RP_BASE until Paul confirms the mbts prefix, which keeps today's
// behaviour byte-for-byte identical. Trailing slash is normalised so the
// replacement value can be written with or without one.
const AUTH_RP_RAW = process.env.REACT_APP_AUTH_RP_BASE || RP_BASE;
export const AUTH_RP_BASE = AUTH_RP_RAW.endsWith('/') ? AUTH_RP_RAW : `${AUTH_RP_RAW}/`;

// Google Identity Services web client. Deliberately has no fallback — the Google
// button stays hidden until the ID is configured, rather than failing at sign-in.
export const GOOGLE_WEB_CLIENT_ID = process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID || '';
